const config = {
	// BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
	BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
	REACT_APP_RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
};

export default config;
